// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__3DDsM","isGray":"Tag_isGray__1FwpR"};